import { isPhoneNumberE164 } from "@sp-crm/core";
import { ResponsiveMode } from "store/reducers/responsive";

export type PhoneAction = "telecom" | "device" | "none";

export const telecomAvailable = (value: string, phoneLineCount: number): boolean =>
    isPhoneNumberE164(value) && phoneLineCount > 0;

export const phoneAction = (
    value: string,
    phoneLineCount: number,
    responsiveMode: ResponsiveMode,
): PhoneAction => {
    if (telecomAvailable(value, phoneLineCount)) {
        return "telecom";
    }

    if (!isPhoneNumberE164(value)) {
        return "none";
    }

    return responsiveMode < ResponsiveMode.large ? "device" : "none";
};
